import environment from 'environment';
import { getRequest, postRequest } from '..';

const { AMAZON_BASE_URL } = environment.eCommerce;

export const amazonPostQuery = postRequest(AMAZON_BASE_URL);
export const amazonGetQuery = getRequest(AMAZON_BASE_URL);
